import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import appConfig from '../../app.config'
import SmoothCollapse from 'react-smooth-collapse'

interface Props {
	backgroundColor: string
	id: number
	onClick: any
	children: any
	color: any
	content: any
	expanded?: boolean
	chevron?: boolean
	className?: string
}

export function ExpandableComponent({
	id,
	children,
	onClick,
	color,
	content,
	backgroundColor,
	expanded = false,
	chevron = true,
	className = '',
}: Props) {
	const [expand, setExpand] = useState(expanded)
	useEffect(() => {
		setExpand(expanded || appConfig.country === 'dk')
	}, [expanded])

	return (
		<div key={id} className={className}>
			<div
				style={{
					backgroundColor: backgroundColor,
					border: '.5px solid #e9e8da', // Most common border. Cream dark here.
					borderLeft: `3px solid ${color}`,
				}}
				className="home-page-container-expand pointer"
				onClick={() => onClick(setExpand(!expand))}>
				<div className="d-flex align-items-center justify-content-between h-100">
					{content}
					{chevron && appConfig.country !== 'dk' && (
						<FontAwesomeIcon
							icon={!expand ? 'chevron-down' : 'chevron-up'}
							className="d-flex mr-4"
						/>
					)}
				</div>
			</div>
			<SmoothCollapse
				expanded={expand}
				children={children}
				allowOverflowWhenOpen={true}
			/>
		</div>
	)
}